var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showBack)?_c('div',{staticClass:"globalBackBtn",on:{"click":_vm.goBack}},[_c('van-icon',{staticClass:"backIcon",attrs:{"name":"arrow-left"}}),_c('span',{staticClass:"backText"},[_vm._v("返回")])],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }